import React, { FunctionComponent } from "react";
import styles from "./Footer2.module.scss";
import Footer2Props from "./Footer2Props.interface";
import SocialLinks from "./components/SocialLinks/SocialLinks";
import setFooterStyles from "./hooks/setFooterStyles";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import IconViewer from "components/IconViewer/IconViewer";

const Footer2: FunctionComponent<Footer2Props> = (props) => {
    let footer: any;
    if (props?.theme?.footer && props?.theme?.footer.length > 0) {
        footer = props?.theme?.footer?.[0]?.content;
    }

    const footerStyles = setFooterStyles(footer);

    const imageAspectRatio = getImageAspectRatio(undefined, footer?.footerLogo?.umbracoWidth, footer?.footerLogo?.umbracoHeight);
    const certificationIcon = props?.certificationIcon?.toLowerCase().replace(/ /g, "-");

    return (
        <footer className={styles.wrapper} style={footerStyles}>
            {/* Top */}
            <div className={styles.top_wrapper}>
                <div className={styles.top}>
                    {footer?.footerLogo ? (
                        <ImageViewer className={styles.image} src={footer.footerLogo.umbracoFile.src} extensionType="png" type="contain" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    ) : null}

                    <SocialLinks {...props} />
                </div>
            </div>

            {/* Bottom */}
            <div className={styles.bottom_wrapper}>
                <div className={styles.bottom}>
                    <div className={styles.copyright}>&copy; {new Date().getFullYear()} Copyright {props.theme?.siteName}</div>

                    <div className={styles.links_wrapper}>
                        {props.certificationIcon && props.certificationLink && props.certificationLink.length > 0 ? (
                            <Anchor className={styles.certification} to={props.certificationLink?.[0].content.link}>
                                <IconViewer name={certificationIcon} />
                                <p>{props.certificationLink?.[0].content.label}</p>
                            </Anchor>
                        ) : null}

                        {props.footerLinks && props.footerLinks.length > 0 ? (
                            <nav>
                                {props.footerLinks?.map((footerLink: any, index: number) => {
                                    return (
                                        <Anchor key={index} className={styles.link} to={footerLink.content.link}>
                                            {footerLink.content.label}
                                        </Anchor>
                                    );
                                })}
                            </nav>
                        ) : null}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer2;